import { Seo } from "components/Seo";
import BulletpointsPromo from "pages/Account/Webshop/Promo/BulletpointsPromo";
import ExtraLinksPromo from "pages/Account/Webshop/Promo/ExtraLinksPromo";
import InfoTextPromo from "pages/Account/Webshop/Promo/InfoTextPromo";
import LogoPromo from "pages/Account/Webshop/Promo/LogoPromo";
import SearchWordsPromo from "pages/Account/Webshop/Promo/SearchWordsPromo";
import { Link } from "react-router-dom";
import { UrlPath } from "utility/routes";

const BoughtAllProductsView = () => {
    return (<>
    <Seo title="Legg til ekstra informasjon om bedriften" />
                            <div className="card mt-3">
                                <div className="card-body">
                                    <h1 className="h3">Legg til ekstra informasjon om bedriften</h1>
                                    <p>Du har kjøpt alt av tilgjengelige produkter!</p>
    
                                    <p className="mt-4 mb-0">
                                        <Link to={UrlPath.MyAccount.Home} className="btn btn-outline-primary">
                                            <i className="bi bi-arrow-left"></i> Tilbake
                                        </Link>
                                    </p>
                                </div>
                            </div>
                            <LogoPromo showBuyPromo={false}></LogoPromo>
                                            <BulletpointsPromo showBuyPromo={false} ></BulletpointsPromo>
                                            <InfoTextPromo showBuyPromo={false}></InfoTextPromo>
                                            <ExtraLinksPromo showBuyPromo={false}></ExtraLinksPromo>
                                            <SearchWordsPromo></SearchWordsPromo>
                        </>)
}

export default BoughtAllProductsView;
    